import { useMediaQuery } from '@react-hook/media-query';
import React from 'react'
const ContactUs = () => {
  const isSmallScreen = useMediaQuery('only screen and (max-width: 670px)');

  return (
    <>
    <div className="flex  bg-background flex-col sm:flex-row h-min[100vh] sm:px-6 lg:px-16">
      <div className="sm:w-3/6 flex-shrink-0 h-content bg-background flex flex-col  mx-6 sm:mt-6 lg:mt-16  ">
        <div className='px-1 w-[100%] py-2'>
          <p className=" items-start  font-Montserrat font-bold" style={{fontSize:"26.1px"}}>
            Contact
          </p>
        </div>
        <div className='p-1'>
              <p className=" sm:text-base font-bold font-Montserrat text-justify" style={{fontSize:"16px",fontStyle:"italic"}}>
                Thank you for your interest in reaching out to us. We value your feedback, inquiries, and suggestions. Please feel free to get in touch with us.             
              </p>
        </div>
        <div className='p-1'>
              <p className=" sm:text-base  font-poppins text-justify" style={{fontSize:"14px"}}>
              If you prefer to send us a message directly, please fill out the form. Our team will review your message and respond to you as soon as possible.  
              </p>     
        </div>
        <div className='mt-4 '>
            <span className='ml-1 font-bold'>E-mail:</span>
            <a className='ml-3'>info@vineshprints.com</a>
        </div>
      </div>
    {/* Right div */}
      <div className="sm:w-3/6 sm:bg-background h-content lg:p-2 sm:p-0 font-poppins flex lg:ml-10 sm:ml-0 mx-6 sm:mt-2 lg:mt-16">
        <div className="flex flex-col w-[100%] ">
            <div className='bg-button w-[100%] flex m-2   p-2'>
              <label className=' text-xs font-bold'>NAME</label>
              <input className='w-[85%] text-xs bg-button border-none focus:border-none focus:outline-none ml-2' type='text'/>
            </div>
            <div className=' bg-button w-[100%] flex m-2  p-2'>
              <label className={`${isSmallScreen?`w-[20%]` : ""} text-xs font-bold`}>EMAIL</label>
              <input className='w-[85%] text-xs bg-button border-none focus:border-none focus:outline-none ml-2' type='text'/>
            </div>
            <div className='  bg-button w-[100%] flex m-2  p-2'>
              <label className=' text-xs font-bold'>SUBJECT</label>
              <input className='w-[85%] text-xs bg-button border-none focus:border-none focus:outline-none ml-2' type='text'/>
            </div>
            <div className='bg-button w-[100%] flex m-2  p-2'>
              <label className=' text-xs font-bold'>MESSAGE</label>
              <textarea className='w-[100%] text-xs bg-button  border-none focus:border-none focus:outline-none ml-2 resize-none' type='text' rows={7} cols={80}/>
            </div>
            <div className='w-[100%] justify-end flex m-1  '>
              <button className='bg-button font-semibold text-white flex  py-1 px-10 rounded-3xl'>
                SUBMIT
              </button>
            </div>
        </div>
      </div>
    </div>
  </>
  )
}

export default ContactUs





